import React from 'react';
import styled from 'styled-components';
import { I18n } from 'react-i18next';
import { t, getBaseLocaleURL } from 'src/utils/translate';

import Button from 'components/Button';
import BannerImage from 'components/BannerImage';

const Hero = () => {
  return (
    <I18n>
      {(translate, { i18n }) => {
        return (
          <BannerImage>
            <Content>
              <Title>{t('home.title')}</Title>
              <Subtitle>{t('home.subtitle')}</Subtitle>
              <p>{t('home.copy')}</p>
              <Button to={`${getBaseLocaleURL(i18n)}/register`}>{t('home.registerBtn')}</Button>
            </Content>
          </BannerImage>
        );
      }}
    </I18n>
  );
};

const Content = styled.div`
  width: 100%;
  max-width: 640px;
  padding: 0 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  p {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 1.5;
  }
`;

const Title = styled.h1`
  font-size: 36px;
  margin-bottom: 10px;
`;

const Subtitle = styled.h2`
  margin-bottom: 60px;
  font-family: ${({ theme }) => theme.fontBold};
  font-size: 11px;
  letter-spacing: 1.8px;
`;

export default Hero;



// WEBPACK FOOTER //
// ./src/pages/Home/elements/Hero.js